import type { Log } from '@/graphql.types'

const ansiRegex =
  // eslint-disable-next-line no-control-regex
  /[\u001B\u009B][[\]()#;?]*.{0,2}(?:(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><])/g

export const cleanMessage = (message: string) => message.replace(ansiRegex, '')

export const logsToText = (logs: Log[]) =>
  logs.map((log) => cleanMessage(log.message ?? '')).join('\n')
